(() => {
  if (customElements.get('mini-set-builder')) return;
  class MiniSetBuilder extends HTMLElement {
    connectedCallback() {
      if(this.initialized) return;
      this.initialized=true;this.form=this.querySelector('[data-mini-form]');
      if(!this.form) return;
      this.variants=JSON.parse(this.querySelector('[data-mini-variants]').textContent);
      this.scents=Array.from(this.querySelectorAll('[data-scent]'));
      this.counts=Array(this.scents.length).fill(0);
      this.addEventListener('click',e=>{
        const card=e.target.closest('[data-scent]');if(!card)return;
        const index=this.scents.indexOf(card), total=this.total();
        if(e.target.closest('[data-plus]') && total<10)this.counts[index]++;
        if(e.target.closest('[data-minus]') && this.counts[index]>0)this.counts[index]--;
        this.update();
      });
      this.form.addEventListener('submit',e=>{
        this.update();
        if(!this.selected || !this.selected.available || this.total()<4 || this.total()>10){e.preventDefault();return;}
        // Exactly one variant line. Per-scent counts are properties, never extra cart items.
        this.form.querySelector('[name="quantity"]').value='1';
        if(this.submitting){e.preventDefault();return;}
        this.submitting=true;
        const button=this.querySelector('[data-mini-add]');button.disabled=true;button.textContent='Adding set…';
      });
      this.onPageShow=()=>{this.submitting=false;this.update();};
      window.addEventListener('pageshow',this.onPageShow);
      this.update();
    }
    disconnectedCallback(){window.removeEventListener('pageshow',this.onPageShow);}
    total(){return this.counts.reduce((a,b)=>a+b,0);}
    update(){
      const total=this.total();this.selected=this.variants.find(v=>v.count===total);
      const display=this.selected||this.variants.find(v=>v.count===4);
      this.scents.forEach((card,i)=>{
        card.querySelector('output').textContent=String(this.counts[i]);
        card.querySelector('[data-minus]').disabled=this.counts[i]===0;
        card.querySelector('[data-plus]').disabled=total>=10;
        const property=card.querySelector('[data-scent-property]');property.value=String(this.counts[i]);property.disabled=this.counts[i]===0;
        card.classList.toggle('is-selected',this.counts[i]>0);
      });
      if(display){this.querySelector('[data-mini-price]').textContent=display.price;this.querySelector('[data-mini-compare]').textContent=display.compare;}
      this.querySelector('[data-mini-id]').value=this.selected?String(this.selected.id):'';
      this.querySelector('[data-mini-total-property]').value=String(total);
      this.querySelector('[data-mini-count]').textContent=`${total} / 10 selected`;
      this.querySelector('progress').value=total;
      const valid=total>=4&&total<=10&&this.selected?.available;
      const add=this.querySelector('[data-mini-add]');add.disabled=!valid;add.textContent=valid?`Add set to Cart · ${this.selected.price}`:'Add set to Cart';
      this.querySelector('[data-mini-hint]').textContent=total<4?`Pick ${4-total} more to continue`:!this.selected?.available?'This set size is unavailable':total===9?'Add your 10th mini at no extra cost':total===10?'Your 10th mini is free':'Your set is ready';
    }
  }
  customElements.define('mini-set-builder',MiniSetBuilder);
})();
